module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff2?569693c9f5d42d769c7f87b90856219a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2
// module id = YcFN
// module chunks = 29